import { gql } from '@apollo/client';

export const ANALYZE_ADDRESS_SIMPLE = gql`
    query AnalyzeAddressSimple(
        $streetAddress: String!
        $unit: String
        $city: String!
        $state: String!
        $zipCode: String!
    ) {
        analyzeAddressSimple(
            streetAddress: $streetAddress
            unit: $unit
            city: $city
            state: $state
            zipCode: $zipCode
        ) {
            normalizedComponents {
                addressLine1
                cityName
                stateAbbreviation
                zipcode
            }
            coordinates {
                latitude
                longitude
            }
            isValid
            validationReason
        }
    }
`;

export interface AddressComponentsOutput {
    addressLine1: string;
    /** 地址库拆出的第二行（单元号等），后端 AddressComponentsType 一直有返回 */
    addressLine2?: string | null;
    cityName?: string | null;
    stateAbbreviation?: string | null;
    zipcode?: string | null;
}

export interface CoordinatesOutput {
    latitude?: number | null;
    longitude?: number | null;
}

export interface AnalyzeAddressSimpleOutput {
    normalizedComponents?: AddressComponentsOutput | null;
    coordinates?: CoordinatesOutput | null;
    isValid: boolean;
    validationReason?: string | null;
}

export interface AnalyzeAddressSimpleResponse {
    analyzeAddressSimple?: AnalyzeAddressSimpleOutput | null;
}

export interface AnalyzeAddressSimpleVariables {
    streetAddress: string;
    unit?: string | null;
    city: string;
    state: string;
    zipCode: string;
}
